import { createWidget } from "@opendash/plugin-monitoring";
import React from "react";
import { ConfigInterface } from "./types";

export default createWidget<ConfigInterface>({
  type: "opendash-widget-pattern",
  meta: {},
  displayComponent: React.lazy(() => import("./component")),
  settingsComponent: React.lazy(() => import("./settings")),

  dataItems: {
    select: "dimension",
    min: 1,
    max: 1,
    types: ["Number"],
  },

  dataFetching: {
    history: true,
    historyRequired: true,
  },

  dataExplorer: {
    title: "highcharts:explorer.pattern.title",
    description: "highcharts:explorer.pattern.description",
    icon: "fa:spider-web",
    config: {
      type: "polar",
      aggregationGroup: "hourOfDay",
      aggregationOperation: "sum",
    },
  },
  hideDataFilter: true,
  presets: [
    {
      label: "highcharts:explorer.timepattern.title",
      layout: [6, 6],
      description: "highcharts:explorer.timepattern.description",
      tags: ["charttime"],
      imageLink: async () => (await import("./res_polar")).default,
      widget: {
        config: {
          type: "polar",
          aggregationGroup: "hourOfDay",
          aggregationOperation: "mean",
        },
      },
    },
    {
      label: "highcharts:explorer.timepattern.title_line",
      description: "highcharts:explorer.timepattern.description",
      layout: [6, 6],
      tags: ["charttime"],
      imageLink: async () => (await import("./res_line")).default,
      widget: {
        config: {
          type: "spline",
          aggregationGroup: "hourOfDay",
          aggregationOperation: "mean",
        },
      },
    },
  ],
});
